import { IHrDepartment, IHrDepartmentData } from '../hr-department.types';
import { HrDepartment } from '../hr-department';

export const mockHrDepartmentsData = (): IHrDepartmentData[] => [
  {
    id: 27,
    name: 'Controls',
    code: 104
  },
  {
    id: 9,
    name: 'Customer Care',
    code: null
  },
  {
    id: 11,
    name: 'Finance',
    code: null
  },
  {
    id: 4,
    name: 'Sales',
    code: null
  }
];

export const mockHrDepartments = (
  data: IHrDepartmentData[] = mockHrDepartmentsData()
): IHrDepartment[] => data.map(item => new HrDepartment(item));
